import type { BufferEditor } from '~publish/legacy/editor/BufferEditor/types.plate'

/**
 *
 */
export function removeSelection({ editor }: { editor: BufferEditor }): void {
  const selection = window?.getSelection?.()
  selection?.removeAllRanges()

  editor.tf.deselect()
}
